import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import { useNavigate, useParams } from 'react-router-dom';
import { ProjectWorkPhaseReport, WorkPhaseReportForm } from './models/investors';
import useProjectWorkPhaseReports from './hooks/useProjectWorkPhaseReports';
import WorkPhaseReportsTable from './components/WorkPhaseReportsTable';
import WorkPhaseReportCreateForm from './components/WorkPhaseReportCreateForm';

const InvestorProjectWorkPhaseReports = () => {
  const { id = '', phaseId = '' } = useParams();
  const navigate = useNavigate();
  const {
    doGetReports,
    doCreateReport,
    doSetVisibility,
    doUploadMedia,
    doDeleteMedia,
    apiErrors,
  } = useProjectWorkPhaseReports();

  const [reports, setReports] = useState<ProjectWorkPhaseReport[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    doGetReports(id, phaseId)
      .then(setReports)
      .finally(() => setLoaded(true));
  }, [id, phaseId]);

  const handleCreateReport = async (form: WorkPhaseReportForm) => {
    const result = await doCreateReport(id, phaseId, form);
    if (result === 201) navigate(0);
  };

  const handleToggleVisibility = async (reportId: string, isVisible: boolean) => {
    const result = await doSetVisibility(id, phaseId, reportId, isVisible);
    if (result === 200) navigate(0);
  };

  const handleUploadMedia = async (reportId: string, formData: FormData) => {
    const result = await doUploadMedia(id, phaseId, reportId, formData);
    if (result === 200) navigate(0);
  };

  const handleDeleteMedia = async (reportId: string, path: string) => {
    const result = await doDeleteMedia(id, phaseId, reportId, path);
    if (result === 200) navigate(0);
  };

  return (
    <AdminPage name="Reportes de Avance de Obra" parentName="Proyectos">
      <Row>
        <Col md="7">
          <h5>Reportes registrados</h5>
          <WorkPhaseReportsTable
            reports={reports}
            loaded={loaded}
            apiErrors={apiErrors}
            onToggleVisibility={handleToggleVisibility}
            onUploadMedia={handleUploadMedia}
            onDeleteMedia={handleDeleteMedia}
          />
        </Col>
        <Col md="5">
          <h5>Nuevo reporte</h5>
          <WorkPhaseReportCreateForm handleForm={handleCreateReport} />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default InvestorProjectWorkPhaseReports;
